let Constants = {
  emailRegExp:
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  phoneRegExp: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/,

  findingsFilterOptions: [
    { label: "LungRADS 4b", value: "4b" },
    { label: "LungRADS 4x", value: "4x" },
    { label: "LungRADS 4", value: "4" },
    { label: "LungRADS 3", value: "3" },
    { label: "LungRADS 2", value: "2" },
  ],
  switchOptions: [
    { label: "Only Findings", value: true },
    { label: "All Results", value: false },
  ],
  statusFilterOptions: [
    { label: "Pending Analysis", value: "pending" },
    { label: "Analysis Completed", value: "complete" },
  ],
  userTypeOptions: [
    { label: "Disabled", value: "disabled" },
    { label: "Enabled", value: "enabled" },
  ],
};

export default Constants;
